// CRM mock data
export interface Deal {
  id: string;
  title: string;
  company: string;
  contactId: string;
  contactName: string;
  value: number;
  probability: number;
  stage: 'lead' | 'qualified' | 'proposal' | 'negotiation' | 'closed-won' | 'closed-lost';
  expectedCloseDate: Date;
  ownerId: string;
  ownerName: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface Contact {
  id: string;
  name: string;
  email: string;
  phone: string;
  company: string;
  title: string;
  status: 'lead' | 'prospect' | 'customer' | 'churned';
  score: number;
  tags: string[];
  lastContactedAt?: Date;
  createdAt: Date;
}

export interface Activity {
  id: string;
  type: 'call' | 'email' | 'meeting' | 'note' | 'task';
  title: string;
  description: string;
  contactId: string;
  contactName: string;
  dealId?: string;
  userId: string;
  userName: string;
  createdAt: Date;
  completedAt?: Date;
}

export const mockDeals: Deal[] = [
  {
    id: 'deal-1',
    title: 'Enterprise Software License',
    company: 'TechCorp Inc.',
    contactId: 'contact-1',
    contactName: 'James Wilson',
    value: 150000,
    probability: 80,
    stage: 'negotiation',
    expectedCloseDate: new Date('2024-02-15'),
    ownerId: 'u13',
    ownerName: 'Kevin Hart',
    createdAt: new Date('2024-01-05'),
    updatedAt: new Date('2024-01-20'),
  },
  {
    id: 'deal-2',
    title: 'Annual Subscription Renewal',
    company: 'Global Solutions Ltd.',
    contactId: 'contact-2',
    contactName: 'Sarah Chen',
    value: 75000,
    probability: 90,
    stage: 'proposal',
    expectedCloseDate: new Date('2024-02-01'),
    ownerId: 'u30',
    ownerName: 'Dwight Schrute',
    createdAt: new Date('2024-01-10'),
    updatedAt: new Date('2024-01-18'),
  },
  {
    id: 'deal-3',
    title: 'Cloud Migration Project',
    company: 'DataFlow Systems',
    contactId: 'contact-3',
    contactName: 'Michael Roberts',
    value: 250000,
    probability: 60,
    stage: 'qualified',
    expectedCloseDate: new Date('2024-03-30'),
    ownerId: 'u13',
    ownerName: 'Kevin Hart',
    createdAt: new Date('2024-01-08'),
    updatedAt: new Date('2024-01-19'),
  },
  {
    id: 'deal-4',
    title: 'Security Audit Services',
    company: 'SecureNet Corp',
    contactId: 'contact-4',
    contactName: 'Emily Zhang',
    value: 45000,
    probability: 95,
    stage: 'closed-won',
    expectedCloseDate: new Date('2024-01-15'),
    ownerId: 'u30',
    ownerName: 'Dwight Schrute',
    createdAt: new Date('2023-12-20'),
    updatedAt: new Date('2024-01-15'),
  },
  {
    id: 'deal-5',
    title: 'Mobile App Development',
    company: 'StartupX',
    contactId: 'contact-5',
    contactName: 'Alex Johnson',
    value: 85000,
    probability: 40,
    stage: 'lead',
    expectedCloseDate: new Date('2024-04-15'),
    ownerId: 'u13',
    ownerName: 'Kevin Hart',
    createdAt: new Date('2024-01-18'),
    updatedAt: new Date('2024-01-20'),
  },
  {
    id: 'deal-6',
    title: 'API Integration Package',
    company: 'ConnectHub Inc.',
    contactId: 'contact-6',
    contactName: 'David Lee',
    value: 32000,
    probability: 70,
    stage: 'proposal',
    expectedCloseDate: new Date('2024-02-28'),
    ownerId: 'u30',
    ownerName: 'Dwight Schrute',
    createdAt: new Date('2024-01-12'),
    updatedAt: new Date('2024-01-19'),
  },
  {
    id: 'deal-7',
    title: 'Consulting Services',
    company: 'Innovation Labs',
    contactId: 'contact-7',
    contactName: 'Lisa Park',
    value: 120000,
    probability: 50,
    stage: 'qualified',
    expectedCloseDate: new Date('2024-03-15'),
    ownerId: 'u13',
    ownerName: 'Kevin Hart',
    createdAt: new Date('2024-01-14'),
    updatedAt: new Date('2024-01-20'),
  },
  {
    id: 'deal-8',
    title: 'Support Contract Extension',
    company: 'RetailMax',
    contactId: 'contact-8',
    contactName: 'Tom Anderson',
    value: 28000,
    probability: 20,
    stage: 'closed-lost',
    expectedCloseDate: new Date('2024-01-10'),
    ownerId: 'u30',
    ownerName: 'Dwight Schrute',
    createdAt: new Date('2023-12-15'),
    updatedAt: new Date('2024-01-10'),
  },
];

export const mockContacts: Contact[] = [
  {
    id: 'contact-1',
    name: 'James Wilson',
    email: 'j.wilson@techcorp.com',
    phone: '+1 (555) 111-2222',
    company: 'TechCorp Inc.',
    title: 'VP of Engineering',
    status: 'customer',
    score: 85,
    tags: ['enterprise', 'tech', 'decision-maker'],
    lastContactedAt: new Date('2024-01-20'),
    createdAt: new Date('2023-06-15'),
  },
  {
    id: 'contact-2',
    name: 'Sarah Chen',
    email: 's.chen@globalsolutions.com',
    phone: '+1 (555) 222-3333',
    company: 'Global Solutions Ltd.',
    title: 'CTO',
    status: 'customer',
    score: 92,
    tags: ['enterprise', 'renewal', 'champion'],
    lastContactedAt: new Date('2024-01-18'),
    createdAt: new Date('2022-11-20'),
  },
  {
    id: 'contact-3',
    name: 'Michael Roberts',
    email: 'm.roberts@dataflow.com',
    phone: '+1 (555) 333-4444',
    company: 'DataFlow Systems',
    title: 'Director of IT',
    status: 'prospect',
    score: 68,
    tags: ['mid-market', 'cloud', 'evaluating'],
    lastContactedAt: new Date('2024-01-19'),
    createdAt: new Date('2024-01-08'),
  },
  {
    id: 'contact-4',
    name: 'Emily Zhang',
    email: 'e.zhang@securenet.com',
    phone: '+1 (555) 444-5555',
    company: 'SecureNet Corp',
    title: 'Security Manager',
    status: 'customer',
    score: 78,
    tags: ['security', 'compliance', 'satisfied'],
    lastContactedAt: new Date('2024-01-15'),
    createdAt: new Date('2023-09-10'),
  },
  {
    id: 'contact-5',
    name: 'Alex Johnson',
    email: 'alex@startupx.io',
    phone: '+1 (555) 555-6666',
    company: 'StartupX',
    title: 'Founder & CEO',
    status: 'lead',
    score: 45,
    tags: ['startup', 'mobile', 'new'],
    lastContactedAt: new Date('2024-01-20'),
    createdAt: new Date('2024-01-18'),
  },
  {
    id: 'contact-6',
    name: 'David Lee',
    email: 'd.lee@connecthub.com',
    phone: '+1 (555) 666-7777',
    company: 'ConnectHub Inc.',
    title: 'Product Manager',
    status: 'prospect',
    score: 62,
    tags: ['integration', 'api', 'technical'],
    lastContactedAt: new Date('2024-01-19'),
    createdAt: new Date('2024-01-12'),
  },
  {
    id: 'contact-7',
    name: 'Lisa Park',
    email: 'l.park@innovationlabs.com',
    phone: '+1 (555) 777-8888',
    company: 'Innovation Labs',
    title: 'COO',
    status: 'prospect',
    score: 55,
    tags: ['consulting', 'enterprise', 'evaluating'],
    lastContactedAt: new Date('2024-01-20'),
    createdAt: new Date('2024-01-14'),
  },
  {
    id: 'contact-8',
    name: 'Tom Anderson',
    email: 't.anderson@retailmax.com',
    phone: '+1 (555) 888-9999',
    company: 'RetailMax',
    title: 'IT Director',
    status: 'churned',
    score: 25,
    tags: ['retail', 'lost', 'competitor'],
    lastContactedAt: new Date('2024-01-10'),
    createdAt: new Date('2022-05-08'),
  },
];

export const mockActivities: Activity[] = [
  {
    id: 'act-1',
    type: 'call',
    title: 'Discovery Call',
    description: 'Discussed requirements for enterprise software license. Client interested in premium features.',
    contactId: 'contact-1',
    contactName: 'James Wilson',
    dealId: 'deal-1',
    userId: 'u13',
    userName: 'Kevin Hart',
    createdAt: new Date('2024-01-20T10:30:00'),
    completedAt: new Date('2024-01-20T11:15:00'),
  },
  {
    id: 'act-2',
    type: 'email',
    title: 'Proposal Sent',
    description: 'Sent updated proposal with revised pricing for annual subscription renewal.',
    contactId: 'contact-2',
    contactName: 'Sarah Chen',
    dealId: 'deal-2',
    userId: 'u30',
    userName: 'Dwight Schrute',
    createdAt: new Date('2024-01-18T14:00:00'),
    completedAt: new Date('2024-01-18T14:00:00'),
  },
  {
    id: 'act-3',
    type: 'meeting',
    title: 'Technical Demo',
    description: 'Presented cloud migration solution to technical team. Good reception, follow-up scheduled.',
    contactId: 'contact-3',
    contactName: 'Michael Roberts',
    dealId: 'deal-3',
    userId: 'u13',
    userName: 'Kevin Hart',
    createdAt: new Date('2024-01-19T09:00:00'),
    completedAt: new Date('2024-01-19T10:30:00'),
  },
  {
    id: 'act-4',
    type: 'note',
    title: 'Contract Signed',
    description: 'Security audit contract signed. Implementation to begin next week.',
    contactId: 'contact-4',
    contactName: 'Emily Zhang',
    dealId: 'deal-4',
    userId: 'u30',
    userName: 'Dwight Schrute',
    createdAt: new Date('2024-01-15T16:00:00'),
  },
  {
    id: 'act-5',
    type: 'task',
    title: 'Send Mobile App Specs',
    description: 'Prepare and send detailed specifications for mobile app development project.',
    contactId: 'contact-5',
    contactName: 'Alex Johnson',
    dealId: 'deal-5',
    userId: 'u13',
    userName: 'Kevin Hart',
    createdAt: new Date('2024-01-20T08:00:00'),
  },
  {
    id: 'act-6',
    type: 'call',
    title: 'Follow-up Call',
    description: 'Discussed API integration timeline and technical requirements.',
    contactId: 'contact-6',
    contactName: 'David Lee',
    dealId: 'deal-6',
    userId: 'u30',
    userName: 'Dwight Schrute',
    createdAt: new Date('2024-01-19T15:30:00'),
    completedAt: new Date('2024-01-19T16:00:00'),
  },
  {
    id: 'act-7',
    type: 'email',
    title: 'Introduction Email',
    description: 'Sent introduction email with case studies and consulting services overview.',
    contactId: 'contact-7',
    contactName: 'Lisa Park',
    dealId: 'deal-7',
    userId: 'u13',
    userName: 'Kevin Hart',
    createdAt: new Date('2024-01-20T11:00:00'),
    completedAt: new Date('2024-01-20T11:00:00'),
  },
  {
    id: 'act-8',
    type: 'note',
    title: 'Lost to Competitor',
    description: 'Client chose competitor due to lower pricing. Mark as lost.',
    contactId: 'contact-8',
    contactName: 'Tom Anderson',
    dealId: 'deal-8',
    userId: 'u30',
    userName: 'Dwight Schrute',
    createdAt: new Date('2024-01-10T17:00:00'),
  },
];

// CRM stats
export const crmStats = {
  totalDeals: 8,
  openDeals: 6,
  totalPipeline: 712000,
  pipelineChange: 18.5,
  wonDeals: 1,
  wonValue: 45000,
  lostDeals: 1,
  lostValue: 28000,
  avgDealSize: 89000,
  winRate: 50,
};

// Pipeline stages
export const pipelineStages = [
  { stage: 'Lead', count: 1, value: 85000, color: 'gray' },
  { stage: 'Qualified', count: 2, value: 370000, color: 'blue' },
  { stage: 'Proposal', count: 2, value: 107000, color: 'cyan' },
  { stage: 'Negotiation', count: 1, value: 150000, color: 'orange' },
  { stage: 'Closed Won', count: 1, value: 45000, color: 'green' },
  { stage: 'Closed Lost', count: 1, value: 28000, color: 'red' },
];
